'use client';

import { useCallback, useEffect, useRef } from 'react';
import { getAssetUrl } from 'lib/config/assetUrls';
import styles from './PressLogos.module.css';

export const PressLogos = ({ className }: { className?: string }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const animate = useCallback(() => {
    const width = contentRef.current?.getBoundingClientRect().width ?? 0;
    if (width > window.innerWidth) {
      const spacing = (width - window.innerWidth) / 2;
      contentRef.current?.style.setProperty('--spacing', `${spacing}px`);
      contentRef.current?.style.setProperty('--spacingInv', `${-spacing}px`);
      contentRef.current?.style.setProperty('--timing', `${spacing / 10}s`);
      contentRef.current?.classList.add(styles.animate);
    } else {
      contentRef.current?.classList.remove(styles.animate);
    }
  }, []);

  useEffect(() => {
    animate();

    window.addEventListener('resize', animate);
    return () => {
      window.removeEventListener('resize', animate);
    };
  }, []);

  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <div ref={contentRef}>
        <img
          loading="lazy"
          src={getAssetUrl('/Press/press_logo-AssociatedPress.svg')}
          alt="Associated Press"
          width={210}
          height={38}
        />
        <img
          loading="lazy"
          src={getAssetUrl('/Press/press_logo-BusinessInsider.svg')}
          alt="Business Insider"
          width={130}
          height={41}
        />
        <img
          loading="lazy"
          src={getAssetUrl('/Press/press_logo-Cnet.svg')}
          alt="Cnet"
          width={48}
          height={46}
        />
        <img
          loading="lazy"
          src={getAssetUrl('/Press/press_logo-MorningStar.svg')}
          alt="Morning Star"
          width={194}
          height={41}
        />
        <img
          loading="lazy"
          src={getAssetUrl('/Press/press_logo-TechCrunch.svg')}
          alt="Tech Crunch"
          width={71}
          height={48}
        />
        <img
          loading="lazy"
          src={getAssetUrl('/Press/press_logo-Forbes.svg')}
          alt="Forbes"
          width={52}
          height={14}
        />
        <img
          loading="lazy"
          src={getAssetUrl('/Press/press_logo-FinancialTimes.svg')}
          alt="Financial Times"
          width={318}
          height={26}
        />
        <img
          loading="lazy"
          src={getAssetUrl('/Press/press_logo-MarketWatch.svg')}
          alt="Market Watch"
          width={174}
          height={25}
        />
        <img
          loading="lazy"
          src={getAssetUrl('/Press/press_logo-YahooFinance.svg')}
          alt="Yahoo Finance"
          width={132}
          height={48}
        />
      </div>
    </div>
  );
};
